import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ERROR } from '../../constants/routes';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasError } = this.state;
    if (hasError && !prevState?.hasError) {
      const { history } = this.props;
      history.replace(`${ERROR}/500`);
      window.location.reload();
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log(`Unhandle error found ${error}, ${errorInfo}`);
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    //if sentry is initialized, capture the exception
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  profiles: state.profiles,
  buttons: state.buttons,
  screenings: state.screenings,
});

export default withRouter(connect(mapStateToProps)(ErrorBoundary));
